/**
 * Retrieves API configuration from the request context when running on server
 * @returns {Object} The API configuration object or an empty object if not available
 */
let getAPIConfigFromContext = () => ({});

// Only attempt to access request context in a server environment
if (typeof window === 'undefined') {
  try {
    // eslint-disable-next-line global-require
    const { requestContext } = require('@fastify/request-context');

    getAPIConfigFromContext = () => {
      try {
        return requestContext.get('apiConfig') || {};
      } catch (error) {
        // Log a sanitized error message without exposing the full error object
        console.warn('Failed to retrieve API config from request context');
        return {};
      }
    };
  } catch (error) {
    // Log a sanitized error message without exposing the full error object
    console.warn('Request context module not available on server');
  }
}

let fastifyRequestContext = null;

// Only attempt to access request context in a server-side environment.
if (typeof window === 'undefined') {
  try {
    // Dynamically import the module to avoid breaking client-side builds.
    // eslint-disable-next-line global-require
    const { requestContext } = require('@fastify/request-context');

    // The requestContext might not be available if we are outside a request lifecycle.
    if (requestContext) {
      fastifyRequestContext = requestContext;
    }
  } catch (error) {
    // This can happen if the module isn't installed or if accessing requestContext fails.
    // We can safely ignore this error and proceed without the context.
    console.warn(
      'Could not retrieve httpContext. This is expected during builds or outside of a request.'
    );
  }
}

module.exports = { getAPIConfigFromContext, fastifyRequestContext };
